import { useLocation, useNavigate } from "react-router-dom";
import { classNames } from "../../../helpers/classNames";
import Search from "../../form/Search";
import { encodeId, initialsValue } from "../../../helpers";
import { useSelector } from "react-redux";
import Image from "../Image";
import Indentification from "../Indentification";
import React from "react";

export default function Sidebar({
  data = [],
  getChatInfo = () => {},
  activeChat,
}) {
  const { session } = useSelector((state) => state?.authProvider);
  const navigate = useNavigate();
  const location = useLocation();

  // const data = [
  //   {
  //     _id: 1,
  //     name: "Matriks Studio",
  //     time: "09:35 PM",
  //     lastReply: {
  //       text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five",
  //     },
  //     status: "read",
  //   },
  //   {
  //     _id: 2,
  //     name: "Matriks Lab",
  //     time: "09:35 PM",
  //     lastReply: {
  //       text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five",
  //     },
  //     status: "unRead",
  //   },
  //   {
  //     _id: 3,
  //     name: "Buddhadev Haldar",
  //     time: "09:35 PM",
  //     lastReply: {
  //       text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five",
  //     },
  //     status: "pending",
  //   },
  //   {
  //     _id: 4,
  //     name: "Sirsendu kundu",
  //     time: "09:35 PM",
  //     lastReply: {
  //       text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five",
  //     },
  //     status: "send",
  //   },
  // ];
  return (
    <div className="w-full md:w-96 bg-chestnut-rose/20 border-r p-4 overflow-y-auto h-screen relative z-10 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-chestnut-rose/60">
      <h2 className="font-bold text-xl mb-4 text-center xls:text-left">
        Messages
      </h2>
      <div className="space-y-4">
        <Search placeholder="Search Messages" />
        {/* Add pinned and message list here */}
        <div className="">
          {/* Single message preview */}
          {data?.map((item, i) => (
            <button
              key={i}
              className={classNames(
                "py-3 px-2 flex items-center space-x-2 cursor-pointer w-full h-16 rounded-md transition-all duration-200 overflow-hidden relative",
                item?.message?.chatId === activeChat
                  ? "bg-chestnut-rose text-white"
                  : "hover:bg-chestnut-rose/10"
              )}
              type="button"
              onClick={() => {
                getChatInfo(item);
                navigate(
                  location?.pathname +
                    `?id=${btoa(
                      encodeId({
                        scholarshipId: item?.scholarshipDetails?._id,
                        // subject: item?.message?.subject,
                        chatId: item?.message?.chatId,
                        senderId: session?.user?._id,
                      })
                    )}`
                );
              }}
            >
              {!item?.seen && (
                <span
                  className={classNames(
                    "flex w-2 h-2 rounded-full absolute top-1 right-1",
                    item?.message?.chatId === activeChat
                      ? "bg-white"
                      : "bg-chestnut-rose"
                  )}
                ></span>
              )}
              <div className="flex -space-x-5">
                {[...(item?.participants || [])]?.map((participant, i) => (
                  <div
                    key={i}
                    className="rounded-full bg-white w-9 min-w-9 h-9 flex-grow-0 overflow-hidden relative before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-chestnut-rose/40 shadow-md"
                  >
                    <div className="absolute top-0 left-0 w-full h-full">
                      {participant?.image?.url ? (
                        <Image
                          effect={"fade"}
                          src={participant?.image?.url}
                          alt={`${participant?.firstName} ${participant?.lastName}`}
                        />
                      ) : (
                        <Indentification
                          initial={initialsValue(
                            `${participant?.firstName} ${participant?.lastName}`
                          )}
                          size="sm"
                          className={"w-full h-full"}
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex-grow w-full max-w-[calc(100%-36px)] overflow-hidden">
                <div className="flex justify-between items-center flex-grow">
                  <div className="font-medium whitespace-nowrap max-w-[calc(100%-64px)] truncate">
                    {[...(item?.participants || [])]
                      ?.map(
                        (participant) =>
                          `${participant?.firstName} ${participant?.lastName}`
                      )
                      ?.join(", ")}
                  </div>
                  <span
                    className={classNames(
                      "text-shades-05 text-xs whitespace-nowrap flex-grow-0 w-16",
                      item?.message?.chatId === activeChat
                        ? "text-shades-03"
                        : ""
                    )}
                  >
                    {item?.time}
                  </span>
                </div>
                <div className={"h-5 flex items-center gap-2"}>
                  {session?.user?._id === item?.message?.from && (
                    <span className="text-xs">
                      {item?.status === "send" && (
                        <i className="fa-regular fa-check"></i>
                      )}
                      {(item?.status === "read" ||
                        item?.status === "unRead") && (
                        <i
                          className={classNames(
                            item?.status === "unRead"
                              ? "fa-regular fa-check"
                              : "fa-regular fa-check-double",
                            item?.status === "read" &&
                              item?.message?.chatId !== activeChat
                              ? "text-chestnut-rose"
                              : item?.status === "read" &&
                                item?.message?.chatId === activeChat
                              ? "!text-blue-zodiac"
                              : "",
                            item?.message?.chatId === activeChat
                              ? "text-shades-03"
                              : ""
                          )}
                        ></i>
                      )}
                      {item?.status === "pending" && (
                        <i className="fa-regular fa-clock"></i>
                      )}
                    </span>
                  )}
                  <p
                    className={classNames(
                      "text-gray-500 line-clamp-1",
                      item?.seen ? "text-xs" : "font-bold text-sm",
                      item?.message?.chatId === activeChat
                        ? "text-shades-03"
                        : ""
                    )}
                  >
                    {item?.message?.attachment ? (
                      <span className={classNames("flex items-center gap-1")}>
                        attachment{" "}
                        <i className="fa-fw fa-light fa-paperclip"></i>
                      </span>
                    ) : (
                      item?.message?.text || item?.message?.parentText
                    )}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
